import {gql} from "@apollo/client"

export const ADD_FAVORITE = gql`
    mutation add_favorite($nid: Int!) {
        addFavoriteToLibrary(nid: $nid) {
            result {
                success
                message
            }
        }
    }
`

export const DELETE_FAVORITE = gql`
    mutation delete_favorite($nid: Int!) {
        deleteFavorite(nid: $nid) {
            result {
                success
                message
            }
        }
    }
`